import { createFunctionLibrary } from '@wix/thunderbolt-becky-root'
import type { SiteAssetsModule, SiteMapModelInstance } from '@wix/thunderbolt-becky-root'
import { typedModelFactory } from './helpers/typedModelFactory'
import { resolveBeckyModel } from './helpers/resolveBeckyModel'
import { maybeAppendErrorPages } from '../errorPages/getPayloadWithErrorPage'
import byRefModule from '../byRef'
import { BeckyFetch } from './utils/beckyFetch'
import { getBeckyTopology } from './helpers/topologyBuilder'
import schemas from '@wix/document-services-json-schemas/dist/refData.json'

export const getSiteMapItems = typedModelFactory<SiteMapModelInstance>(
	require('@wix/thunderbolt-becky-carmi-ds/src/carmi/siteMap.carmi')
)

const sitemapModule: SiteAssetsModule<SiteMapModelInstance> = (moduleContext) => {
	const { httpClient, metricsReporter, topologyGetter, logger } = moduleContext
	const fetchFn = BeckyFetch(httpClient.fetch, metricsReporter, logger)
	const funcLib = createFunctionLibrary({
		fetch: fetchFn,
		metricsReporter,
		schemas,
	})
	const byRef = byRefModule(moduleContext)

	return {
		execute: async (payload) => {
			const beckyTopology = getBeckyTopology(topologyGetter, payload)

			return byRef
				.execute(maybeAppendErrorPages(payload))
				.then((payloadWithResolvedRefs) =>
					resolveBeckyModel({
						payload: payloadWithResolvedRefs,
						beckyTopology,
						fetchFn,
						metricsReporter,
						logger,
					})
				)
				.then((beckyModel) =>
					funcLib.runAsyncAndReport(
						() => new Promise((done) => getSiteMapItems(beckyModel, { ...funcLib, done })),
						'tb-site-map-model-calculation'
					)
				)
		},
	}
}

export default sitemapModule
